/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Passkey_Remove_ConfirmInputs */

const en_passkey_remove_confirm = /** @type {(inputs: Passkey_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}? You can no longer sign in with it.`)
};

const de_passkey_remove_confirm = /** @type {(inputs: Passkey_Remove_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entfernen? Damit kannst du dich dann nicht mehr anmelden.`)
};

/**
* | output |
* | --- |
* | "Remove {name}? You can no longer sign in with it." |
*
* @param {Passkey_Remove_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_remove_confirm = /** @type {((inputs: Passkey_Remove_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Remove_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_remove_confirm(inputs)
	return en_passkey_remove_confirm(inputs)
});